/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

export class CheckboxTreeNode<T> {
  constructor(public title: string,
              public value: T,
              public checked: boolean,
              public indeterminate?: boolean,
              public parent?: CheckboxTreeNode<T>,
              public children?: CheckboxTreeNode<T>[],
              public symbolicName?: string) {

  }
}
